import { ETrackingType, ITracker } from '../entities/IAnalytics';
import { IDispatch } from '../tools/reduxTools';
import { ADD_TRACKING, IAnalyticsTypes } from './actionTypes/analyticsTypes';

export const setTracking = (trackingType: ETrackingType, tracker: ITracker): IDispatch<IAnalyticsTypes['ADD_TRACKING']> => ({
    type: ADD_TRACKING,
    trackingType,
    tracker
});
